import { StatusCode } from 'grpc-web';
// A rejected gRPC call that keeps its status code. Services wrap the raw
// RpcError in a readable message; keeping the code lets callers branch on the
// kind of failure instead of parsing that message.
export class GrpcCallError extends Error {
    constructor(message, code) {
        super(message);
        this.name = 'GrpcCallError';
        this.code = code;
    }
}
export const isPermissionDenied = (err) => err instanceof GrpcCallError && err.code === StatusCode.PERMISSION_DENIED;
